import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";

class ThankyouView extends Component {

  render() {
    function ContactByMail(href) {
      var subject = "More information about the game";
      var uri = "mailto:bmvanbaren@innersense.nl,ssanches@innersense.nl?subject=";
      uri += encodeURIComponent(subject);
      window.open(uri);
    }


    const style = {
      margin: {
        marginBottom: "20px"
      },
      alignment: {
        textAlign: "left"
      }
    };

    return (
      <section>
        <div>
          <div className="container">
            <Typography
              variant="headline"
              style={{ fontSize: "20px", marginTop: "15px" }}
            >
              Thank you for playing!< br/>
            </Typography>
            <Typography style={style.margin} component="div">
              < br/>Success in developing  a sustainable way of life!< br/>
              For more information on the game for team building please contact us< br/>
            </Typography>
            <Button
              variant="raised"
              style={{ marginBottom: "20px" }}
              color="primary"
            >
              <a style={{ color: "white" }} onClick={() => ContactByMail()}>
                Contact us
              </a>
            </Button>
            <Typography style={style.margin} component="div">
            </Typography>
            <Link to={"/"}>
              <Button variant="raised" style={style.margin} color="primary">
                Finish
              </Button>
            </Link>
          </div>
        </div>
      </section>
    );
  }
}

export default ThankyouView;



// WEBPACK FOOTER //
// ./src/views/ThankyouView.jsx